import { Pipe, PipeTransform } from '@angular/core';
@Pipe({name: 'inArray'})
export class InArrayPipe implements PipeTransform {
  transform(array: any[], value: string): boolean {
    return array?.includes(value);
  }
}
